import { env } from "configs/EnvironmentConfig";
import { ALL_BU } from "constants/DashboardContanst";
import fetch from "../auth/FetchInterceptor";

const ErrorInvoiceService = {};

// Thông báo hóa đơn sai sót
ErrorInvoiceService.listInvoiceErrors = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code,
  bu_parent,
  isTaxDeduct
) {
  const url = isTaxDeduct ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// Chi tiết thông báo hóa đơn sai sót
ErrorInvoiceService.detailInvoiceErrors = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/${id}`,
    method: "get",
  });
};

// Hóa đơn sai sót
ErrorInvoiceService.listInvoiceInvoiceErrors = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code,
  bu_parent
) {
  return fetch({
    url: `${env.API_MSP}/invoice-invoice-errors`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// reviewPdfRegisterInvoice
ErrorInvoiceService.reviewPdfErrorInvoice = function (
  id,
  patch = "review-pdf",
  isTaxDeduct = false
) {
  const url = isTaxDeduct ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}/${patch}/${id}`,
    method: "get",
  });
};
// ErrorInvoiceService
ErrorInvoiceService.downloadFileXML = (
  resource_id,
  responseType,
  isTaxDeduct = false
) => {
  const url = isTaxDeduct ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// Create Error Invoices
ErrorInvoiceService.createErrorInvoices = ({ data }, bu_code) => {
  const url = data.lctdt ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Error Invoices
ErrorInvoiceService.editErrorInvoices = (data, id) => {
  const url = data.lctdt ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}/${id}`,
    method: "put",
    data,
  });
};

// transfer
ErrorInvoiceService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// Release Error Invoices
ErrorInvoiceService.releaseErrorInvoices = (id, isTaxDeduct) => {
  const url = isTaxDeduct ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}/release/${id}`,
    method: "post",
  });
};

// Delete Error Invoices
ErrorInvoiceService.deleteErrorInvoices = (id, isTaxDeduct) => {
  const url = isTaxDeduct ? `tax-deduct-errors` : `invoice-errors`;
  return fetch({
    url: `${env.API_MSP}/${url}/${id}`,
    method: "delete",
  });
};

// Search Invoice Error Invoices
ErrorInvoiceService.searchInvoiceErrorInvoices = ({ params }, bu_code) => {
  const url = params.sctu
    ? `tax-deduct-errors/search`
    : `invoice-errors/search-invoice`;
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "get",
    params: {
      ...params,
      bu_code: bu_code,
      expand: params.expand || "",
    },
  });
};
// List Type Invoice Error Invoices
ErrorInvoiceService.listTypeInvoiceErrorInvoices = ({ params }) => {
  const url = params.isTaxDeduct
    ? `tax-deduct-errors/get-type`
    : `invoice-errors/get-type-invoice`;
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "",
    },
  });
};

// List Notification Properties Error Invoices
ErrorInvoiceService.listNotificationPropertiesErrorInvoices = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/invoice-errors/get-nature`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "",
    },
  });
};

export default ErrorInvoiceService;
